import React, { useState } from "react";
import HeaderLayout from "../../components/Header";
import FooterLayout from "../../components/Footer";
import { useSearchParams } from "react-router-dom";

const Terms = () => {
  const [searchParams] = useSearchParams();
  const isModule = searchParams.get("app");

  return (
    <>
      {isModule === "true" ? [] : <HeaderLayout />}
      <div>
        <div
          style={{
            padding: "2rem",
            fontFamily: "Arial, sans-serif",
            lineHeight: "1.6",
          }}
        >
          <h2 align="center">Terms & Conditions</h2>
          <p>
            By using the Bonoxi website and services, you agree to the following
            terms and conditions.
          </p>

          <h3>1. Use of Service</h3>
          <p>Bonoxi provides tools to:</p>
          <ul>
            <li>Convert Word, Excel, and PowerPoint files to PDF.</li>
            <li>Generate QR codes from text or URLs.</li>
          </ul>
          <p>These services are intended for lawful use only.</p>

          <h3>2. User Responsibility</h3>
          <p>You are solely responsible for:</p>
          <ul>
            <li>The content you upload or input.</li>
            <li>
              Ensuring your documents do not violate copyright or contain
              sensitive data.
            </li>
            <li>Downloading your results before the session ends.</li>
          </ul>

          <h3>3. Limitation of Liability</h3>
          <ul>
            <li>Bonoxi is not liable for loss of files or data.</li>
            <li>
              Bonoxi is not liable for errors in conversion or QR code
              generation.
            </li>
            <li>
              Bonoxi is not liable for any damages resulting from the use of our
              services.
            </li>
          </ul>

          <h3>4. Intellectual Property</h3>
          <p>
            All website content, branding, and features are the property of
            Bonoxi and cannot be copied or reused without permission.
          </p>

          <h3>5. Service Availability</h3>
          <p>
            We reserve the right to modify, suspend, or discontinue our services
            without notice at any time.
          </p>

          <h3>6. Termination</h3>
          <p>
            We may restrict access or terminate accounts that violate these
            terms.
          </p>

          <h3>7. Governing Law</h3>
          <p>
            These Terms are governed by and construed in accordance with the
            laws of your country/state.
          </p>

          <p>
            For any queries, reach out to:{" "}
            <a href="mailto:support@bonoxi.com">support@bonoxi.com</a>
          </p>
          <hr />
          <p>
            <strong>Effective Date:</strong> May 15, 2025
          </p>
        </div>
      </div>
      {isModule === "true" ? [] : <FooterLayout />}
    </>
  );
};

export default Terms;
